import api from "../../api";
import { createNewMeasure } from "../../helpers/measures.helpers";

export const convertMeasureConfigToMeasure = ({ id, title, description }: api.MeasureConfig): api.Measure => ({
  ...createNewMeasure(),
  title,
  description,
  measure_config_id: id
});
